import { RoomId, roomId, RoomMixerId, roomMixerId } from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomMixerErrorEventVO {
  private static validation = JsonSchemaValidator.compile(
    RoomMixerErrorEventVO.validationSchema()
  );

  constructor(readonly value: RoomMixerErrorEvent) {
    JsonSchemaValidator.assert(RoomMixerErrorEventVO.validation, value);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId", "error"],
      properties: {
        roomId,
        mixerId: roomMixerId,
        error: {
          type: "string",
          minLength: 0,
          maxLength: 1024
        }
      },
      additionalProperties: false
    };
  }
}

interface RoomMixerErrorEvent {
  roomId: RoomId;
  mixerId?: RoomMixerId;
  error: string;
}
